import { render, staticRenderFns } from "./JobListingNotifications.vue?vue&type=template&id=8965cde0"
import script from "./JobListingNotifications.vue?vue&type=script&lang=js"
export * from "./JobListingNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8965cde0')) {
      api.createRecord('8965cde0', component.options)
    } else {
      api.reload('8965cde0', component.options)
    }
    module.hot.accept("./JobListingNotifications.vue?vue&type=template&id=8965cde0", function () {
      api.rerender('8965cde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/JobListingNotifications.vue"
export default component.exports